import { CategoryFormSettings } from "../modules/shared/model";

/**
 * Calculate emergency exit cost based on time slot and day type
 * This function replicates the logic from AllJobsComponent
 */
export const calculateEmergencyCost = (
  emergencyTimeSlot: any,
  emergencyDays: any,
  categoryFormSettings: CategoryFormSettings | CategoryFormSettings[] | null
): number => {
  // Get settings from category form settings
  let settings = null;
  if (categoryFormSettings) {
    if (Array.isArray(categoryFormSettings) && categoryFormSettings.length > 0) {
      settings = categoryFormSettings[0];
    } else if (typeof categoryFormSettings === "object" && !Array.isArray(categoryFormSettings)) {
      settings = categoryFormSettings;
    }
  }

  if (!settings) return 80; // Default fallback

  // Get time slot and day type IDs
  const timeSlotId = Number(emergencyTimeSlot?.id);
  const dayTypeId = Number(emergencyDays?.id);

  // Determine the price based on time slot and day type
  let price = 80; // Default fallback

  if (timeSlotId === 1) { // Day (6 AM - 6 PM)
    if (dayTypeId === 1) { // Weekday
      price = settings.DayWeekdayPrice || 80;
    } else if (dayTypeId === 2) { // Weekend
      price = settings.DayWeekendPrice || 80;
    } else if (dayTypeId === 3) { // Holiday
      price = settings.DayHolidayPrice || 80;
    }
  } else if (timeSlotId === 2) { // Evening (6 PM - 10 PM)
    if (dayTypeId === 1) { // Weekday
      price = settings.EveningWeekdayPrice || 80;
    } else if (dayTypeId === 2) { // Weekend
      price = settings.EveningWeekendPrice || 80;
    } else if (dayTypeId === 3) { // Holiday
      price = settings.EveningHolidayPrice || 80;
    }
  } else if (timeSlotId === 3) { // Night (10 PM - 6 AM)
    if (dayTypeId === 1) { // Weekday
      price = settings.NightWeekdayPrice || 80;
    } else if (dayTypeId === 2) { // Weekend
      price = settings.NightWeekendPrice || 80;
    } else if (dayTypeId === 3) { // Holiday
      price = settings.NightHolidayPrice || 80;
    }
  }

  return price;
};
